import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const rootElm = document.querySelectorAll("#root, #ctroot, #filterroot, #fproot")[0];
const props = {};
props.lang =  (`${  rootElm.getAttribute('lang') || document.documentElement.getAttribute('lang') || 'en'}`).slice(0,2);
props.showClosingTimes = false;

if (rootElm.id === "ctroot") {
  props.showClosingTimes = true;
}
else if (rootElm.id === "filterroot") {
  props.showFilters = true;
}
else if (rootElm.id === "fproot") {
  props.showOverviewSimple = true;
}

if (rootElm) {
  ReactDOM.render(<App {...props} />, rootElm);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js